<template>
  <div>
    <div class="anm22-calendar-wrapper-calendar" style="min-height: 100px">
      <div
        class="anm22-calendar-label"
        style="font-weight: 100; font-size: 20px"
      >
        {{ $anm22.strLang(lang, "Users selected", "Utenti Selezionati") }}
      </div>
      <div id="matesContainer"></div>
      <wg-search
        :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
        :debounceTime="2000"
        :mode="'offline'"
        :searchFn="searchUser"
        :clickFn="addUser"
      ></wg-search>
    </div>
    <span
      v-for="(u, i) in selected.map((id) => $store.getters['users/get'](id))"
      :key="'u-' + i"
    >
      <div
        class="anm22-calendar-invite-container anm22-calendar-wrapper-calendar"
      >
        <img
          class="anm22-calendar-round anm22-calendar-invite-img"
          :src="$anm22.getObjIcon(u, 'userDefault')"
        />
        {{ u.name }} {{ u.surname }}
      </div>
    </span>
    <span v-if="selected.length > 0">
      <input
        type="button"
        class="action-button anm22-calendar-input-submit"
        @click="setFilter"
        :value="$anm22.strLang(lang, 'Start Search', 'Avvia Ricerca')"
      />
    </span>
  </div>
</template>

<style></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      selected: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    users() {
      return this.$store.getters["users/getAll"];
    },
  },

  methods: {
    searchUser(string) {
      const regexp = new RegExp(string, "i");
      return this.users
        .filter((u) => {
          return (
            -1 !== u.name.search(regexp) ||
            -1 !== u.surname.search(regexp) ||
            -1 !== u.email.search(regexp)
          );
        })
        .map((u) => {
          return { id: u.idWorldUser, label: u.name + " " + u.surname };
        });
    },
    addUser(id) {
      this.selected.push(id);
    },
    setFilter() {
      this.$http
        .post(
          "events/geteventsofusers",
          {
            users: this.selected,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: response.data.events,
            }),
          ]).then(() => {
            this.selected.forEach((id) => {
              const u = this.$store.getters["users/get"](id);
              this.$anm22.eventBus.$emit("users-avaiability", {
                name: u.name,
                id: id,
              });
            });
            this.$anm22.eventBus.$emit("wg-modal-close");
          });
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style>
.anm22-calendar-wrapper-calendar {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0;
  margin-bottom: 20px;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
}
hr {
  border: 1px solid #ecf0f1;
  color: #ecf0f1;
}
</style>
